
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/home" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/2315105bcc52647a42d8293f39d3fb09/a399ce152c5c62654fa82e31632c27dd.png" 
              alt="Descuentos en Luz"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link 
              to="/servicios-luz" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8F00]' : 'text-white hover:text-[#FF8F00]'
              }`}
            >
              Servicios
            </Link>
            <Link 
              to="/empresas" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8F00]' : 'text-white hover:text-[#FF8F00]'
              }`}
            >
              Empresas
            </Link>
            <Link 
              to="/solar" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8F00]' : 'text-white hover:text-[#FF8F00]'
              }`}
            >
              Solar
            </Link>
            <Link 
              to="/blog" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8F00]' : 'text-white hover:text-[#FF8F00]'
              }`}
            >
              Blog
            </Link>
            <Link 
              to="/subir-factura" 
              className="bg-[#FF8F00] hover:bg-[#E68000] text-white px-6 py-2.5 rounded-full font-bold transition-all cursor-pointer whitespace-nowrap"
            >
              Revisar factura
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-gray-900 cursor-pointer"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <Link 
              to="/servicios-luz" 
              className="block py-2 text-gray-700 hover:text-[#FF8F00] font-medium cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Servicios
            </Link>
            <Link 
              to="/empresas" 
              className="block py-2 text-gray-700 hover:text-[#FF8F00] font-medium cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Empresas
            </Link>
            <Link 
              to="/solar" 
              className="block py-2 text-gray-700 hover:text-[#FF8F00] font-medium cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Solar
            </Link>
            <Link 
              to="/blog" 
              className="block py-2 text-gray-700 hover:text-[#FF8F00] font-medium cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link 
              to="/subir-factura" 
              className="block w-full bg-[#FF8F00] hover:bg-[#E68000] text-white px-6 py-3 rounded-full font-bold text-center cursor-pointer whitespace-nowrap"
              onClick={() => setIsMenuOpen(false)}
            >
              Revisar factura
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
